import { DataBean } from "../DataBean";

export class AdquisitionPlanByYear extends DataBean {


    public async getAdquisitionPlanByYear(year: any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.orange.bean.supplier.AdquisitionPlan_getAdquisitionPlanByYear_Number", [year]);
    }

}